// extracted by mini-css-extract-plugin
export default {"container":"ok-z","blurb":"pk-z","links":"qk-z"};